import React from 'react';
import { motion } from 'framer-motion'; // Add framer-motion
import { BiCreditCardAlt, BiShieldQuarter, BiAnalyse } from 'react-icons/bi';
import { FiExternalLink } from 'react-icons/fi';

const solutions = [
{
  icon: BiCreditCardAlt,
  bgColor: '#075816',
  title: 'Seamless Payment Processing',
  desc: 'Enable customers to pay easily using credit cards, UPI, wallets, all through one reliable gateway.',
},

  {
    icon: BiShieldQuarter,
    bgColor: '#075816',
    title: 'Advanced Security & Compliance',
    desc: 'Protect transactions with industry-standard encryption, fraud detection, and compliance with global regulations.',
  },
  {
    icon: BiAnalyse,
    bgColor: '#075816',
    title: 'Scalable Enterprise Infrastructure',
    desc: 'Engineered for performance, our system scales effortlessly with your growing business needs.',
  },
];

// Container animation for staggered cards
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

// Individual card animation
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

const UnlockRevenue = () => {
  return (
    <motion.section
      className="py-5"
      style={{ background: '#fff' }}
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.2 }}
    >
      <div className="container">
        <h2 className="text-center fw-bold mb-5" style={{fontSize:"40px"}}>
          Payment Solution That Unlock Revenue
        </h2>
        <div className="row justify-content-center g-4">
          {solutions.map((item, idx) => {
            const IconComponent = item.icon;
            return (
              <motion.div
                className="col-md-4"
                key={idx}
                variants={cardVariants}
                whileHover={{ scale: 1.05, rotateZ: 1, transition: { duration: 0.3 } }}
              >
                <div
                  className="revenue-card position-relative p-4"
                  style={{
                    borderRadius: '20px',
                    background: '#fff',
                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                    cursor: 'pointer',
                    transition: 'all 0.4s ease',
                    height:"230px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#32A852';
                    e.currentTarget.querySelector('.icon').style.backgroundColor = '#fff';
                    e.currentTarget.querySelector('.icon svg').style.color = '#32A852';
                    e.currentTarget.querySelector('.title').style.color = '#fff';
                    e.currentTarget.querySelector('.desc').style.color = '#fff';
                    e.currentTarget.querySelector('.link').style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#fff';
                    e.currentTarget.querySelector('.icon').style.backgroundColor = item.bgColor;
                    e.currentTarget.querySelector('.icon svg').style.color = '#fff';
                    e.currentTarget.querySelector('.title').style.color = '#222';
                    e.currentTarget.querySelector('.desc').style.color = '#222';
                    e.currentTarget.querySelector('.link').style.color = item.bgColor;
                  }}
                >
                  <div
                    className="icon mb-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: item.bgColor,
                      color: '#fff',
                      transition: 'all 0.4s ease',
                    }}
                  >
                    <IconComponent size={28} />
                  </div>

                  <h5
                    className="title"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '18px',
                      color: '#222',
                      transition: 'color 0.4s ease',
                    }}
                  >
                    {item.title}
                  </h5>

                  <p
                    className="desc"
                    style={{
                      color: '#222',
                      fontSize: '16px',
                      margin: '12px 0 20px',
                      transition: 'color 0.4s ease',
                    }}
                  >
                    {item.desc}
                  </p>

                  <a
                    href="#"
                    className="link text-decoration-none"
                    style={{
                      color: item.bgColor,
                      fontWeight: 500,
                      transition: 'color 0.4s ease',
                    }}
                  >
                    {/* Learn more <FiExternalLink /> */}
                  </a>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
};

export default UnlockRevenue;
